import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import MyButton from '../../UI/form/MyButton';
import { setScannerOpen, setScannerResult } from '../../../store/scannerSlice';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

const ScannerQrFlutter = ({ buttonText, onClickOpen, onClickClose, isCameraOnly }) => {

    
    const [scanning, setScanning] = useState(false)
    const scanTypeUser = useSelector(state => state.user.user.scanType)
    const activate = useSelector(state => state.scanner.activate)
    const open = useSelector(state => state.scanner.open)
    const dispatch = useDispatch()

    useEffect(() => {
        // Примусове відкриття потрібного сканеру, якщо є в налаштуваннях у користувача
        if (scanTypeUser && activate && !isCameraOnly) {
            if (scanTypeUser === 'camera') {
                openScanner()
            } else if (scanTypeUser === 'hid') {
                openHidScanner()
            }
        }
    }, [activate, scanTypeUser])

    useEffect(() => {
        scanned()
    }, [window]);

    useEffect(() => {
        canceled()
    }, [window]);

    const openScanner = () => {
        if (!scanning) {
            if (window.QRInterface) {
                window.QRInterface.postMessage("startScan");
                if (onClickOpen) {
                    onClickOpen(true)
                }
                setScanning(true);
                dispatch(setScannerOpen(true))
            }
            // window.QRInterface.postMessage('startScan');
            // setScanning(true);
        }
    };

    const openHidScanner = () => {
        if (!scanning) {
            if (window.HIDInterface) {
                window.HIDInterface.postMessage("startScanHid");
                if (onClickOpen) {
                    onClickOpen(true)
                }
                setScanning(true);
                dispatch(setScannerOpen(true))
            }
            // window.QRInterface.postMessage('startScan');
            // setScanning(true);
        }
    };

    // Успішно відскановано
    const scanned = () => {
        const handleQR = (e) => {
            const qr = e.detail;
            //   dispatch(setQrCode(qr)); // зберігаємо у Redux
            // alert('Scanner TEXT', qr)
            dispatch(setScannerOpen(false))
            // Зберігаємо результат
            dispatch(setScannerResult(qr))
            // робимо, що потрібно: редирект, API, зміна інтерфейсу тощо

            setScanning(false) // дозволити нове сканування
        };
    
        window.addEventListener("qr-scanned", handleQR);
        return () => window.removeEventListener("qr-scanned", handleQR);
    }

    // Скасоване сканування
    const canceled = () => {
        const handleCancel = () => {
            // console.log('Сканування було скасовано');
            // dispatch(setScannerResult(''))
            if (onClickClose) {
                onClickClose(true)
            } else {
                dispatch(setScannerOpen(false))
            }
            // setScanning(false);
        };

        window.addEventListener('qr-cancelled', handleCancel);
        return () => window.removeEventListener('qr-cancelled', handleCancel);
    }

  return (
    <div className='flutterButtons__scan'>
        {
            scanTypeUser && scanTypeUser === 'hid' && !isCameraOnly ? '' 
            :
            <MyButton
                onClick={e => {
                    if (!open) { // Відкривати новий сканер лише якщо не відкритий інший
                        openScanner()
                    }
                }}
            >
                {
                    buttonText ? buttonText : <QrCodeScannerIcon />
                }
                Телефоном
            </MyButton>
        }

        {
            scanTypeUser && scanTypeUser === 'camera' && !isCameraOnly ? ''
            :
            <MyButton
                onClick={e => {
                    if (!open) { // Відкривати новий сканер лише якщо не відкритий інший
                        openHidScanner()
                    }
                }}
            >
                {
                    buttonText ? buttonText : <QrCodeScannerIcon sx={{color: 'red'}}/>
                }
                сканером {open ? ' (очікування 10 сек...)' : ''}
            </MyButton>
        }
    </div>
  )
}

export default ScannerQrFlutter